/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getQuote = /* GraphQL */ `
  query GetQuote($id: ID!) {
    getQuote(id: $id) {
      id
      userId
      quoteId
      description
      config
      metrics
      bom
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const listQuotes = /* GraphQL */ `
  query ListQuotes(
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        quoteId
        description
        config
        metrics
        bom
        createdAt
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuoteCounter = /* GraphQL */ `
  query GetQuoteCounter($id: ID!) {
    getQuoteCounter(id: $id) {
      id
      currentValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQuoteCounters = /* GraphQL */ `
  query ListQuoteCounters(
    $filter: ModelQuoteCounterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuoteCounters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        currentValue
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const quotesByUserId = /* GraphQL */ `
  query QuotesByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotesByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        quoteId
        description
        config
        metrics
        bom
        createdAt
        owner
        updatedAt
        schemaVersion
        configV2 {
          system {
            systemType interfaceOption networkProtocol rackSize sizeByNodeCount hardwareVendor
            compressionRatio endToEndEncryption
            director { veloCount veloSsdCapacity }
            hybrid {
              enabled minRawCapacity nodeCount vpodSsdCapacity encodingScheme spares
              compressionRatio endToEndEncryption ssdPartNumber jbodSize hddCapacity mlec hddPartNumber
            }
            afa {
              enabled minRawCapacity nodeCount vpodSsdCapacity encodingScheme spares
              compressionRatio endToEndEncryption ssdPartNumber nodeModel
            }
          }
          pricing {
            subscriptionMonths serviceOption quarter discountMonths ssdSoftware hddSoftware
            baseSsdSoftware baseHddSoftware ssdLicenseUnitPrice ssdSupportUnitPrice
            hddLicenseUnitPrice hddSupportUnitPrice
            customPricing {
              overrideSetId vendor quarter customPrices customSkus savedAt
            }
          }
          customMetrics { overrides keys savedAt appVersion }
          metadata {
            preparedFor partnerName quoteDescription notes opportunityID customerID
            customerNumber offerNumber configuratorQuoteSerial salesforceQuoteNumber
            accountExecutive accountExecutiveEmail warrantyStartDate quoteExpirationDate
          }
          viewState {
            isNoReg consultationMode isPBUnit cciEnabled
            hybridEncodingSchemeUserSelected afaEncodingSchemeUserSelected
          }
          unknownFields
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const quotesByCreatedAt = /* GraphQL */ `
  query QuotesByCreatedAt(
    $createdAt: String!
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotesByCreatedAt(
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        quoteId
        description
        config
        metrics
        bom
        createdAt
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserRoles = /* GraphQL */ `
  query ListUserRoles {
    listUserRoles
  }
`;
export const listAuditEvents = /* GraphQL */ `
  query ListAuditEvents(
    $filter: ModelAuditEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAuditEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventType
        artifactType
        quoteSerial
        vendor
        payload
        owner
        createdAt
      }
      nextToken
    }
  }
`;
